import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";

import { useEvents } from "../data-access/calendar-data.provider";
import { Event } from "../types/event-type";

export const useAnniversaryDateEvents = (selectedDate: Dayjs) => {
  //   const date = new URLSearchParams(useLocation().search).get("date");
  const events = useEvents();

  const [dateAnniversaryEvents, setDateAnniversaryEvents] = useState<Event[]>(
    []
  );

  useEffect(() => {
    // const selectedDate = date ? dayjs(JSON.parse(date)) : dayjs();

    const monthEvents: Event[] = events.filter((event) => {
      return selectedDate.month() === dayjs(event.date).month();
    });

    const anniversaryMonthEvents: Event[] = monthEvents.filter((event) =>
      isAnniversary(selectedDate, event.date)
    );

    const anniversaryDateEvents: Event[] = anniversaryMonthEvents.filter(
      (anniversary) => selectedDate.date() === dayjs(anniversary.date).date()
    );

    setDateAnniversaryEvents(anniversaryDateEvents);
  }, [events, selectedDate]);

  return dateAnniversaryEvents;
};

const isAnniversary = (selectedDate: Dayjs, date: string): boolean => {
  const yearDifference = selectedDate.year() - dayjs(date).year();

  return yearDifference % 5 === 0;
};

//   const eventsIds = events.reduce<string[]>((acc, { entityId }) => {
//     acc.push(entityId);
//     return acc;
//   }, []);
